<template lang="pug">
    b-row.position-relative
      OVwithOTData(:item="item", v-if="item.ot")
      b-col(cols="2" v-if="item.repuestos && item.repuestos.length > 0 && !item.ot")
        b-row
          b-col(cols="12")
            <font-awesome-icon :icon="['fa', 'clipboard-list']" />
            span.title.ml-2 Repuestos

        b-row.mt-4( class="align-items-center")
          b-col(cols="12" v-for="(repuesto, index) in item.repuestos || []" :key="index")
            span.subtitle_repuesto Repuesto {{ index + 1 }}
            b-row.mt-2
              b-col(cols="12")
                b-form-group
                  label.categoria_text Categoría del Repuesto
                  span.categoria {{ repuesto.category.name }}
              b-col(cols="12")
                b-form-group
                  label.comentario_text Comentario
                  span.comentarios {{ repuesto.comments }}
      b-col(:cols="(item.repuestos && item.repuestos.length > 0) || item.ot ? 10 : 12")
        .pvp-info-line(v-if="item && item.datos_equipo && (item.datos_equipo.modelo || formatearPrecioPVP(item.datos_equipo.precio_pvp))")
          template(v-if="item.datos_equipo.modelo")
            | Modelo: {{ item.datos_equipo.modelo }}
          template(v-if="item.datos_equipo.modelo && formatearPrecioPVP(item.datos_equipo.precio_pvp)")
            |  | 
          template(v-if="formatearPrecioPVP(item.datos_equipo.precio_pvp)")
            | PVP: {{ formatearPrecioPVP(item.datos_equipo.precio_pvp) }}
        b-row.mb-3
          b-col(cols="12")
            <font-awesome-icon :icon="['fa', 'tools']" />
            span.title.ml-2 Cotizar Repuestos
        b-row.d-flex.repuesto-header-row
          b-col(cols="detalles")
            label.part-number Partes
          b-col(cols="detalles")
            label Descripción
          b-col(cols="partgroup")
            label Partgroup
          b-col(cols="cantidad")
            label Cantidad
          b-col(cols="precio")
            .d-flex.align-items-center
              font-awesome-icon(
                icon="info-circle"
                class="mr-2 price-info-icon"
                id="popover-price-info"
              )
              b-popover(placement="top" :show.sync="showPartPriceInfoPopover" target="popover-price-info")
                div
                  .flex.justify-content-between.align-items-center
                    span Último precio:
                    b {{ partInfo.ultimo_precio | formatCurrency}}
                  .flex.justify-content-between.align-items-center
                    span Porcentaje de aprobación:
                    b &nbsp;{{ partInfo.porcentaje_aprobación }}%
                  .flex.justify-content-between.align-items-center
                    span Porcentaje de aprobación (3 meses):
                    b &nbsp;{{ partInfo.porcentaje_aprobación_3_meses }}%
              label Precio
          b-col(cols="descuento")
            label Desc. %
          b-col(cols="1")
            label Desc. $
          b-col(cols="1")
            label Total
          b-col(cols="delete")
            span &nbsp;
        div(v-for="(item, index) in items" :key="`${index}-item`")
          b-row.d-flex.align-items-center.repuesto-data-row
            b-col(cols="detalles")
              b-form-group.no-margin-bottom
                Autocomplete(
                  :id="`part-number-autocomplete-${index}`"
                  :search="search"
                  placeholder="Buscar parte"
                  :default-value="items[index].partes_name"
                  :get-result-value="r => r.part_number"
                  @submit="(result) => onSubmit(result, index)"
                )
                small.text-danger(v-if="item.required") Campo requerido
            b-col(cols="detalles")
              b-form-group.no-margin-bottom
                b-input-group
                  b-form-input(
                    size="lg"
                    v-model="item.description"
                    placeholder="Descripción"
                    disabled
                  )
            b-col(cols="partgroup")
              b-form-group.no-margin-bottom
                div.form-control.readonly-value {{ item.part_group_description || '-' }}
            b-col(cols="cantidad")
              b-form-group.no-margin-bottom
                b-input-group
                  b-form-input(
                    :id="`part-quantity-input-${index}`"
                    type="number"
                    size="lg"
                    v-model="item.partes_cant"
                    placeholder="Cant."
                    :state="item.partes_cant !== null && item.partes_cant <= 0 ? false : null"
                    @wheel.prevent
                  )
                b-form-invalid-feedback(:state="item.partes_cant !== null && item.partes_cant <= 0 ? false : null")
                  | Campo requerido mayor a 0
            b-col.precio-col(cols="precio")
              b-form-group.no-margin-bottom
                b-input-group
                  CurrencyInput(
                    :id="`part-price-input-${index}`"
                    v-model="item.precio_unitario"
                    placeholder="Ingresa Precio"
                    :state="item.precio_unitario !== null && item.precio_unitario <= 0 ? false : null"
                  )
                //- b-form-invalid-feedback(:state="item.precio_unitario !== null && item.precio_unitario <= 0 ? false : null")
                //-   | Campo requerido mayor a 0
                small.pvp-suggested(v-if="item.pvp_catalogo > 0 && item.part_group_porcentaje > 0")
                    | Sugerido: {{ Math.round(item.pvp_catalogo * item.part_group_porcentaje / 100) | formatCurrency }}
            b-col(cols="descuento")
              b-form-group.no-margin-bottom
                b-input-group
                  b-form-input(
                    :id="`part-discount-input-${index}`"
                    size="lg"
                    type="number"
                    v-model="item.porcentaje_descuento"
                    placeholder="0."
                    min="0"
                    max="100"
                    step="1"
                    @wheel.prevent
                  )
            b-col(cols="1")
              b-form-group.no-margin-bottom
                div.form-control.readonly-value
                  span(v-if="calcularDescuentoItem(item) > 0") {{ calcularDescuentoItem(item) | formatCurrency }}
                  span(v-else) -0
            b-col(cols="1")
              b-form-group.no-margin-bottom
                div.form-control.readonly-value
                  span {{ calcularTotalItem(item) || 0 | formatCurrency }}
            b-col(cols="delete")
              b-form-group.no-margin-bottom
                b-icon.trash-icon(icon="trash-fill" @click="removeItem(index)" style="margin-top: 8px;")


        b-row
          b-col(cols="2")
            div.btn-add-item(id="add-repuesto" @click="addItem").mt-2.mb-4
              font-awesome-icon.icon-add(icon="plus-circle")
              span.ml-2 Añadir repuesto
        b-row.mb-3
          b-col(cols="12")
            <font-awesome-icon :icon="['fa', 'pencil-ruler']" />
            span.title.ml-2 Agregar servicios
        b-row(v-for="(service, idx) in servicios" :key="`${idx}-service`" class="d-flex align-items-center")
          b-col(cols="detalles")
            b-form-group
              label.part-number(v-if="idx === 0") Servicio
              Autocomplete(
                :search="listServices"
                :id="`service-autocomplete-${idx}`"
                placeholder="Buscar servicio"
                submitOnEnter
                aria-label="Buscar servicio"
                :default-value="service.nombre"
                :get-result-value="r => r.nombre"
                @submit="(serviceSelected) => onServiceSubmit(serviceSelected, idx)"
                @change="e => setService(e.target.value, idx)"
              )
              small.text-danger(v-if="service.required") Campo requerido
          b-col(cols="detalles")
            b-form-group
              label(v-if="idx === 0") Descripción
              b-input-group
                b-form-input(v-model="service.descripcion" size="lg" disabled placeholder="Descripción")
          b-col(cols="cantidad")
            b-form-group
              label(v-if="idx === 0") Cant.
              b-input-group
                b-form-input(
                  type="number"
                  size="lg"
                  v-model="service.cantidad"
                  placeholder="Cant."
                  :state="service.cantidad !== null && service.cantidad <= 0 ? false : null"
                  @wheel.prevent
                )
              b-form-invalid-feedback(:state="service.cantidad !== null && service.cantidad <= 0 ? false : null")
                | Campo requerido mayor a 0
          b-col(cols="precio")
            b-form-group
              label(v-if="idx === 0") Precio
              b-input-group
                CurrencyInput(
                  v-model="service.precio"
                  :id="`service-price-input-${idx}`"
                  disabled
                  placeholder="Precio"
                )
          b-col(cols="descuento")
            b-form-group
              label(v-if="idx === 0") Desc. %
              b-input-group
                b-form-input(
                  size="lg"
                  type="number"
                  v-model="service.porcentaje_descuento"
                  placeholder="0"
                  min="0"
                  max="100"
                  step="1"
                  @wheel.prevent
                )
          b-col(cols="1")
            b-form-group
              label(v-if="idx === 0") Desc. $
              b-input-group
                div.form-control.readonly-value
                  span(v-if="calcularDescuentoServicio(service) > 0") {{ calcularDescuentoServicio(service) | formatCurrency }}
                  span(v-else) -
          b-col(cols="1")
            b-form-group
              label(v-if="idx === 0") Total
              b-input-group
                div.form-control.readonly-value
                  span {{ calcularTotalServicio(service) || 0 | formatCurrency }}
          b-col(cols="delete")
            b-form-group.no-margin-bottom
              label(v-if="idx === 0") &nbsp;
              b-input-group
                b-icon.trash-icon(icon="trash-fill" @click="removeService(idx)" style="margin-top: 8px;")
        b-row
          b-col(cols="2")
            div.btn-add-item.mt-2.mb-4(@click="servicios.push({ cantidad: null, porcentaje_descuento: 0 })")
              font-awesome-icon.icon-add(icon="plus-circle")
              span.ml-2 Añadir servicio
        b-row.mb-3
          b-col(cols="12")
            <font-awesome-icon :icon="['fa', 'money-bill']" />
            span.title.ml-2 Montos
        b-row
          b-col(cols="6" class="").d-flex.align-items-center.mb-0

        b-row.d-flex.justify-content-between
          b-col(cols="4")
            div.d-flex.align-items-center.mb-1
              label.title.mb-0 Abono
            b-form-group
              CurrencyInput(
                v-model="abono_requerido"
                id="input-abono-ov"
                placeholder="Abono calculado automáticamente"
                disabled
              )
          b-col(cols="4")
            div.d-flex.align-items-center.mb-1
              b-form-checkbox(v-model="despacho_checked" id="check-despacho" name="check-button").mr-1
              label.title.mb-0 Requiere Despacho
            b-form-group
              b-form-input(
                v-model="despacho_requerido"
                type="number"
                id="input-despacho-ov"
                placeholder="Ingrese monto de despacho en pesos"
                :disabled="!despacho_checked"
                @wheel.prevent
              )
          b-col(cols="4")
            b-row
              b-col(cols="12").mt-2
                span.subtitle_repuesto SubTotal
                span.float-right(class="subtotal-val") {{ subtotal.toFixed(2) | formatCurrency }}
              b-col(cols="12").mt-2
                span.subtitle_repuesto Descuento
                span.float-right(class="discount-val") {{`${descuentoEnPesos > 0 ? '-' : ''} ${$options.filters.formatCurrency(descuentoEnPesos)}`}}
              b-col(cols="12").mt-2
                span.subtitle_repuesto IVA
                span.float-right(class="iva-val") {{ Math.floor((subtotal - descuentoEnPesos) * 0.19) | formatCurrency }}
              b-col.mt-2(cols="12" v-if="despacho_checked && despacho_requerido")
                span.subtitle_repuesto Envio
                span.float-right(class="despacho-val") {{ despacho_requerido | formatCurrency }}
              b-col(cols="12").mt-2
                span.subtitle_repuesto Total
                span.float-right(class="total-val") {{ total | formatCurrency }}
        b-row
          b-col(cols="12")
            b-form-group
              label Comentario
              b-form-input(
                v-model="comentario"
                placeholder="Si es necesario, deja algún comentario"
              )
        b-button.d-flex.align-items-center.position-absolute.px-4.py-1(
          id="generate-quotation-btn"
          v-if="type === 'complete' || type === 'fullNew'"
          style="bottom: -65px; right:15px;"
          variant="primary"
          @click="type === 'complete' ? save() : saveNew()"
          :disabled="loading"
        )
          | {{ loading ? 'Guardando...' : 'Guardar' }}
          b-spinner.ml-2(v-if="loading" small)
  </template>

<script>
import { mapActions } from 'vuex'
import Autocomplete from '@trevoreyre/autocomplete-vue'
import '@trevoreyre/autocomplete-vue/dist/style.css'
import OVwithOTData from './OVwithOTData.vue'
import CurrencyInput from '../CurrencyInput.vue'

export default {
  name: 'ModalCotization',
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
    item: {
      type: Object,
      required: false,
    },
    type: {
      type: String,
      required: false,
    },
    dataNewCot: {
      type: Object,
      default: () => ({}),
      required: false,
    },
    getQuotationData: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Autocomplete,
    OVwithOTData,
    CurrencyInput,
  },
  data() {
    return {
      showPartPriceInfoPopover: false,
      partInfo: {},
      name: '',
      abono_checked: false,
      abono_requerido: 0,
      despacho_checked: false,
      despacho_requerido: '',
      comentario: '',
      items: [
        {
          partes_name: '',
          partes_cant: null,
          precio_unitario: null,
          id_parte: null,
          porcentaje_descuento: 0,
        },
      ],
      servicios: [
        {
          nombre: '',
          precio: 0,
          cantidad: null,
          id: '',
          porcentaje_descuento: 0,
        },
      ],
      inputText: null,
      searching: false,
      selectedPart: null,
      loading: false,
      servicesList: [],
      thereAreParts: true,
      thereAreServices: true,
      hasOtAndParts: false,
      hasOt: false,
    }
  },
  methods: {
    ...mapActions('Diagnosticos', ['searchByPartNumber']),
    ...mapActions('OVStore', ['getPartInfo']),
    ...mapActions('OVStore', [
      'sendQuotation',
      'listAllServices',
      'newOportunidadCompleta',
    ]),
    async onInfoCircleClick(index) {
      if (!this.items[index].id_parte) return
      if (this.showPartPriceInfoPopover) {
        this.showPartPriceInfoPopover = false
        return
      }
      this.partInfo = await this.getPartInfo({
        id_parte: this.items[index].id_parte,
      })
      this.showPartPriceInfoPopover = true
    },
    formatearPrecioPVP(valor) {
      if (!valor || valor === 0) return ''
      return new Intl.NumberFormat('es-CL', {
        style: 'currency',
        currency: 'CLP',
        minimumFractionDigits: 0,
      }).format(valor)
    },
    calcularTotalItem(item) {
      const total = item.partes_cant * item.precio_unitario || 0
      const descuento = parseInt(item.porcentaje_descuento, 10) || 0
      const montoDescuento = Math.round((total * descuento) / 100)
      return total - montoDescuento
    },
    calcularDescuentoItem(item) {
      const total = item.partes_cant * item.precio_unitario || 0
      const descuento = parseInt(item.porcentaje_descuento, 10) || 0
      return Math.round((total * descuento) / 100)
    },
    calcularTotalServicio(service) {
      const total = service.cantidad * service.precio || 0
      const descuento = parseInt(service.porcentaje_descuento, 10) || 0
      const montoDescuento = Math.round((total * descuento) / 100)
      return total - montoDescuento
    },
    calcularDescuentoServicio(service) {
      const total = service.cantidad * service.precio || 0
      const descuento = parseInt(service.porcentaje_descuento, 10) || 0
      return Math.round((total * descuento) / 100)
    },
    closeModal() {
      this.$emit('close')
    },
    addItem() {
      this.items.push({
        partes_name: '',
        partes_cant: null,
        precio_unitario: null,
        pvp_catalogo: null,
        part_group_description: '-',
        part_group_porcentaje: 0,
        id_parte: null,
        porcentaje_descuento: 0,
      })
    },
    removeItem(index) {
      this.items = this.items.filter((_, i) => i !== index)
      this.showPartPriceInfoPopover = false
    },
    removeService(index) {
      this.servicios = this.servicios.filter((_, i) => i !== index)
    },
    async search(input) {
      if (input.length < 3) {
        return []
      }
      try {
        const results = await this.searchByPartNumber({ partNumber: input })
        return results.data.results.map((result) => ({
          ...result,
        }))
      } catch (error) {
        console.error('Error al buscar partes:', error)
        return []
      }
    },
    async listServices(input) {
      if (this.servicesList.length > 0) {
        return this.servicesList.filter((service) =>
          service.nombre.toLowerCase().includes(input.toLowerCase())
        )
      }
      const resp = await this.listAllServices()
      this.servicesList = resp
      return resp
    },
    getResultValue(result) {
      return result.part_number
    },
    setPart(value, index) {
      if (!value || this.items[index].partes_name !== value) {
        this.items[index].id_parte = null
        this.items[index].partes_name = ''
        this.items[index].partes_cant = null
        this.items[index].precio_unitario = null
        this.items[index].required = false
      }
    },
    setService(value, index) {
      if (!value || this.servicios[index].nombre !== value) {
        this.servicios[index].id = null
        this.servicios[index].nombre = ''
        this.servicios[index].precio = null
        this.servicios[index].cantidad = null
        this.servicios[index].descripcion = ''
        this.servicios[index].required = false
      }
    },
    validateParts() {
      const valid = this.items.every(
        (item) =>
          item.partes_cant > 0 && item.precio_unitario > 0 && item.id_parte
      )
      if (!valid) {
        this.items.forEach((item, index) => {
          if (!item.partes_cant > 0) this.items[index].partes_cant = ''
          if (!item.precio_unitario > 0) this.items[index].precio_unitario = ''
          if (!item.id_parte) this.items[index].required = true
        })
      }
      return valid
    },
    validateServices() {
      const valid = this.servicios.every(
        (service) => service.precio > 0 && service.id
      )
      if (!valid) {
        this.servicios = this.servicios.map((service) => {
          if (!service.precio > 0) {
            return {
              ...service,
              required: true,
            }
          }
          return service
        })
      }
      return valid
    },
    onSubmit(result, index) {
      if (!result || !result.id) return

      this.$set(this.items, index, {
        // Usa $set para reactividad
        ...this.items[index],
        id_parte: result.id,
        description: result.description,
        precio_unitario:
          result.ultimo_precio > 0
            ? result.ultimo_precio
            : result.precio_unitario,
        pvp_catalogo: result.precio_unitario,
        part_group_description: result.part_group_description || '-',
        part_group_porcentaje: result.part_group_porcentaje || 0,
        partes_name: result.part_number,
        partes_cant: 1,
        required: false,
        porcentaje_descuento: this.items[index].porcentaje_descuento || 0,
      })
    },
    onServiceSubmit(serviceSelected, index) {
      this.servicios = this.servicios.map((service, idx) => {
        if (idx === index) {
          return {
            id: serviceSelected.id,
            nombre: serviceSelected.nombre,
            precio: serviceSelected.precio,
            cantidad: 1,
            descripcion: serviceSelected.descripcion,
            porcentaje_descuento: service.porcentaje_descuento || 0,
          }
        }
        return service
      })
      this.servicios[index].nombre = serviceSelected.nombre
      this.servicios[index].id = serviceSelected.id
    },
    checkServices() {
      return this.servicios.every((service) => !!service.id)
    },

    async saveNew() {
      if (this.loading) return
      if (
        this.abono_checked &&
        (this.abono_requerido < 0 || this.abono_requerido === '')
      ) {
        this.$bvToast.toast('El abono requerido no puede ser negativo', {
          title: 'Advertencia',
          variant: 'danger',
          solid: true,
        })
        return
      }
      this.thereAreParts =
        this.items.length > 0 && this.items.some((i) => i.id_parte)
      this.thereAreServices =
        this.servicios.length > 0 && this.servicios.some((s) => s.id)

      if (!this.thereAreParts && !this.thereAreServices) {
        this.$bvToast.toast('Debe agregar al menos un repuesto o servicio', {
          title: 'Advertencia',
          variant: 'danger',
          solid: true,
        })
        return
      }

      if (this.thereAreParts) {
        const validParts = this.validateParts()
        if (!validParts) return
      }

      if (this.thereAreServices) {
        const validServices = this.validateServices()
        if (!validServices) return
      }

      if (this.items.length === 0 && this.servicios.length === 0) {
        this.$bvToast.toast('Debe agregar al menos un repuesto o servicio', {
          title: 'Advertencia',
          variant: 'danger',
          solid: true,
        })
        return
      }

      // Agregar items y servicio al dataNewCot
      const serviciosFiltrados = this.servicios.filter(
        (servicio) => Object.keys(servicio).length > 0 && servicio.id
      )
      const itemsFiltrados = this.items.filter(
        (item) => Object.keys(item).length > 0 && item.id_parte
      )
      const tieneIdValido = serviciosFiltrados.some((servicio) => servicio.id)
      const tieneParteValido = itemsFiltrados.some((item) => item.id_parte)
      this.dataNewCot.servicios = tieneIdValido
        ? JSON.stringify(serviciosFiltrados)
        : '[]'
      this.dataNewCot.partes = tieneParteValido
        ? JSON.stringify(itemsFiltrados)
        : '[]'
      this.dataNewCot.requiere_abono = true
      this.dataNewCot.abono_requerido = this.abono_requerido
      this.dataNewCot.requiere_cobro_envio =
        this.despacho_checked === 'true' || this.despacho_checked === true
      this.dataNewCot.costo_envio =
        this.despacho_requerido && this.despacho_checked
          ? parseInt(this.despacho_requerido, 10)
          : 0
      this.dataNewCot.comentario_vendedor = this.comentario
      this.dataNewCot.precios = JSON.stringify({
        subtotal: this.subtotal,
        iva: Math.floor((this.subtotal - this.descuentoEnPesos) * 0.19),
        descuento: this.descuentoEnPesos,
        total: this.total,
      })
      const data = new FormData()
      // data.append('file', this.serialImg)
      Object.entries(this.dataNewCot).forEach(([key, value]) => {
        data.append(key, value)
      })

      this.loading = true
      try {
        const response = await this.newOportunidadCompleta(data)
        if (response.status === 200) {
          const { ov_id } = response.data

          this.$bvToast.toast('Cotización creada correctamente', {
            title: 'Éxito',
            variant: 'success',
            solid: true,
          })
          this.$bvModal.hide('modal-cotization-completo')
          // Redirigir a la nueva oportunidad de venta
          this.$router.push({ name: 'OVDetailView', params: { ov_id } })
        }
      } catch (error) {
        this.$bvToast.toast('Error al crear cotización', {
          title: 'Error',
          variant: 'danger',
          solid: true,
        })
      } finally {
        this.loading = false
      }
    },
    async save() {
      if (
        this.abono_checked &&
        (this.abono_requerido < 0 || this.abono_requerido === '')
      ) {
        this.$bvToast.toast('El abono requerido no puede ser negativo', {
          title: 'Advertencia',
          variant: 'danger',
          solid: true,
        })
        return
      }
      this.thereAreParts =
        this.items.length > 0 && this.items.some((i) => i.id_parte)
      this.thereAreServices =
        this.servicios.length > 0 && this.servicios.some((s) => s.id)

      if (!this.thereAreParts && !this.thereAreServices) {
        this.$bvToast.toast('Debe agregar al menos un repuesto o servicio', {
          title: 'Advertencia',
          variant: 'danger',
          solid: true,
        })
        return
      }

      if (this.thereAreParts) {
        const validParts = this.validateParts()
        if (!validParts) return
      }

      if (this.thereAreServices) {
        const validServices = this.validateServices()
        if (!validServices) return
      }

      if (this.items.length === 0 && this.servicios.length === 0) {
        this.$bvToast.toast('Debe agregar al menos un repuesto o servicio', {
          title: 'Advertencia',
          variant: 'danger',
          solid: true,
        })
        return
      }

      this.loading = true
      try {
        const someNegative = this.servicios.some(
          (service) => parseInt(service.precio, 10) < 0
        )
        if (someNegative) {
          return
        }

        const validServices = this.checkServices()
        if (!validServices) {
          this.$bvToast.toast('Debes elegir entre los servicios disponibles', {
            variant: 'danger',
            solid: true,
          })
          return
        }
        const response = await this.sendQuotation({
          requiere_abono: this.abono_checked,
          abono_requerido: this.abono_requerido ? this.abono_requerido : 0,
          requiere_cobro_envio: this.despacho_checked,
          costo_envio:
            this.despacho_requerido && this.despacho_checked
              ? parseInt(this.despacho_requerido, 10)
              : 0,
          comentario_vendedor: this.comentario,
          items: this.items,
          servicios: this.servicios.map((service) => {
            if (service.id) {
              return {
                ...service,
                precio: parseInt(service.precio, 10) || 0,
              }
            }
            return null
          }),
          id_oportunidad_venta: this.item.id,
          precios: {
            subtotal: this.subtotal,
            iva: Math.floor((this.subtotal - this.descuentoEnPesos) * 0.19),
            descuento: this.descuentoEnPesos,
            total: this.total,
          },
        })
        console.log('  response', response)
        if (response.status === 200) {
          this.$bvToast.toast('Cotización creada.', {
            variant: 'success',
            solid: true,
          })
          this.$bvModal.hide('modal-cotization')
        }

        this.closeModal()
      } catch (error) {
        console.error('Error al guardar cotización:', error)
      } finally {
        this.loading = false
      }
    },
    resetFields() {
      this.name = ''
      this.abono_checked = false
      this.abono_requerido = 0
      this.despacho_checked = false
      this.despacho_requerido = ''
      this.comentario = ''
      this.items = [
        {
          partes_name: '',
          partes_cant: null,
          precio_unitario: null,
          pvp_catalogo: null,
          part_group_description: '-',
          part_group_porcentaje: 0,
          id_parte: '',
          porcentaje_descuento: 0,
        },
      ]
      this.servicios = [
        {
          porcentaje_descuento: 0,
        },
      ]
      this.inputText = null
      this.searching = false
      this.selectedPart = null
    },
    handleModalClose() {
      this.resetFields()
      this.closeModal()
    },
    validateAbono() {
      const abono = parseFloat(this.abono_requerido) || 0
      if (abono > this.subtotal) {
        this.abono_requerido = ''
        this.$bvToast.toast('El abono no puede ser mayor al 100% del total', {
          title: 'Advertencia',
          variant: 'danger',
          solid: true,
        })
      }
    },
  },
  computed: {
    subtotal() {
      // Subtotal SIN descuentos - precio original de items y servicios válidos únicamente
      const itemsTotal = this.items
        .filter(
          (item) =>
            item.id_parte && item.partes_cant > 0 && item.precio_unitario > 0
        )
        .reduce((total, item) => {
          const subtotalItem = item.partes_cant * item.precio_unitario
          return total + subtotalItem
        }, 0)

      const totalServices = this.servicios
        .filter(
          (service) => service.id && service.cantidad > 0 && service.precio > 0
        )
        .reduce((total, service) => {
          const subtotalService =
            parseInt(service.precio, 10) * parseInt(service.cantidad, 10)
          return total + subtotalService
        }, 0)

      return itemsTotal + totalServices
    },
    total() {
      const costo_envio =
        this.despacho_requerido && this.despacho_checked
          ? parseInt(this.despacho_requerido, 10)
          : 0
      // Total = (Subtotal - Descuentos) * 1.19 + Envío
      // La base imponible es subtotal - descuentos
      const baseImponible = this.subtotal - this.descuentoEnPesos
      // IVA sobre la base imponible
      const iva = Math.floor(baseImponible * 0.19)

      return baseImponible + iva + costo_envio
    },
    abono_calculado() {
      const cincuentaPorciento = this.total * 0.5
      // Redondear hacia abajo al próximo múltiplo de 5.000
      const abonoRedondeado = Math.floor(cincuentaPorciento / 5000) * 5000
      return abonoRedondeado
    },
    descuentoEnPesos() {
      // SILL-1152: Calcular descuento como suma de descuentos individuales por ítem
      const descuentoItems = this.items
        .filter(
          (item) =>
            item.id_parte && item.partes_cant > 0 && item.precio_unitario > 0
        )
        .reduce((total, item) => {
          const subtotalItem = item.partes_cant * item.precio_unitario
          const descuento = parseInt(item.porcentaje_descuento, 10) || 0
          const montoDescuento = Math.round((subtotalItem * descuento) / 100)
          return total + montoDescuento
        }, 0)

      const descuentoServicios = this.servicios
        .filter(
          (service) => service.id && service.cantidad > 0 && service.precio > 0
        )
        .reduce((total, service) => {
          const subtotalService =
            parseInt(service.precio, 10) * parseInt(service.cantidad, 10)
          const descuento = parseInt(service.porcentaje_descuento, 10) || 0
          const montoDescuento = Math.round((subtotalService * descuento) / 100)
          return total + montoDescuento
        }, 0)

      return descuentoItems + descuentoServicios
    },
  },
  created() {
    if (this.item) {
      if (this.item.servicios && this.item.servicios.length) {
        this.servicios = this.item.servicios.map((service) => ({
          nombre: service.servicio.nombre,
          descripcion: service.servicio.descripcion,
          precio: service.precio,
          cantidad: service.cantidad,
          id: service.servicio.id,
          porcentaje_descuento: service.porcentaje_descuento || 0,
        }))
      }

      let partes = []
      let partes_ov_rechazada = []
      if (this.item.detalle_venta?.length) {
        partes = this.item.detalle_venta.map((detalle) => ({
          partes_name: detalle.parte.part_number,
          description: detalle.parte.description,
          partes_cant: detalle.cantidad,
          precio_unitario: detalle.precio_unitario,
          pvp_catalogo:
            detalle.parte.precio_unitario || detalle.precio_unitario || 0,
          part_group_description: detalle.parte.part_group_description || '-',
          part_group_porcentaje: detalle.parte.part_group_porcentaje || 0,
          id_parte: detalle.parte.id,
          porcentaje_descuento: detalle.porcentaje_descuento || 0,
        }))
        this.hasOtAndParts = !!(
          this.item.detalle_venta?.length > 0 && this.item.ot
        )
      }
      this.hasOt = !!this.item.ot
      this.abono_checked = !!this.item.ot
      this.despacho_checked = !!this.item.requiere_cobro_envio
      this.despacho_requerido = this.item.costo_envio || ''
      this.comentario = this.item.comentario_vendedor || ''

      if (
        this.item.data_ov_rechazada &&
        this.item.data_ov_rechazada.detalle_venta.length
      ) {
        partes_ov_rechazada = this.item.data_ov_rechazada.detalle_venta.map(
          (detalle) => ({
            partes_name: detalle.parte.part_number,
            description: detalle.parte.description,
            partes_cant: detalle.cantidad,
            precio_unitario: detalle.precio_unitario,
            pvp_catalogo:
              detalle.parte.precio_unitario || detalle.precio_unitario || 0,
            part_group_description: detalle.parte.part_group_description || '-',
            part_group_porcentaje: detalle.parte.part_group_porcentaje || 0,
            id_parte: detalle.parte.id,
            porcentaje_descuento: detalle.porcentaje_descuento || 0,
          })
        )
      }
      const combinedItems = [...partes, ...partes_ov_rechazada]
      this.items = combinedItems.filter(
        (item, index, self) =>
          index === self.findIndex((i) => i.id_parte === item.id_parte)
      )
    }
  },
  watch: {
    getQuotationData(newVal) {
      if (newVal) {
        const quotationPayload = {
          requiere_abono: this.abono_checked,
          abono_requerido: this.abono_requerido ? this.abono_requerido : 0,
          requiere_cobro_envio: this.despacho_checked,
          costo_envio:
            this.despacho_requerido && this.despacho_checked
              ? parseInt(this.despacho_requerido, 10)
              : 0,
          comentario_vendedor: this.comentario,
          items: this.items,
          servicios: this.servicios
            .map((service) => {
              if (service.id) {
                return {
                  ...service,
                  precio: parseInt(service.precio, 10) || 0,
                }
              }
              return null
            })
            .filter((service) => service !== null),
          precios: {
            subtotal: this.subtotal,
            iva: Math.floor((this.subtotal - this.descuentoEnPesos) * 0.19),
            descuento: this.descuentoEnPesos,
            total: this.total,
          },
        }

        console.log('Emitiendo quotation-data:', quotationPayload)
        this.$emit('quotation-data', quotationPayload)
      }
    },
    abono_calculado(newVal) {
      this.abono_requerido = newVal
    },
    showModal(newVal) {
      if (newVal && this.item !== undefined) {
        this.comentario = this.item.comentario_vendedor || ''
        const { data_ov_rechazada } = this.item
        if (this.item.detalle_venta?.length > 0 && !data_ov_rechazada) {
          this.hasOtAndParts = true
          this.items = this.item.detalle_venta.map((detalle) => ({
            partes_name: detalle.parte.part_number,
            partes_cant: detalle.cantidad,
            precio_unitario: detalle.precio_unitario,
            pvp_catalogo:
              detalle.parte.precio_unitario || detalle.precio_unitario || 0,
            part_group_description: detalle.parte.part_group_description || '-',
            part_group_porcentaje: detalle.parte.part_group_porcentaje || 0,
            id_parte: detalle.parte.id,
            porcentaje_descuento: detalle.porcentaje_descuento || 0,
          }))
          return
        }
        if (!data_ov_rechazada) {
          return
        }

        if (
          data_ov_rechazada?.detalle_venta &&
          Array.isArray(data_ov_rechazada.detalle_venta)
        ) {
          this.items = data_ov_rechazada.detalle_venta.map((detalle) => ({
            partes_name: detalle.parte.part_number,
            partes_cant: detalle.cantidad,
            precio_unitario: detalle.precio_unitario,
            pvp_catalogo:
              detalle.parte.precio_unitario || detalle.precio_unitario || 0,
            part_group_description: detalle.parte.part_group_description || '-',
            part_group_porcentaje: detalle.parte.part_group_porcentaje || 0,
            id_parte: detalle.parte.id,
            porcentaje_descuento: detalle.porcentaje_descuento || 0,
          }))

          if (!this.items.length)
            this.items.push({
              partes_name: '',
              partes_cant: null,
              precio_unitario: null,
              pvp_catalogo: null,
              part_group_description: '-',
              part_group_porcentaje: 0,
              id_parte: null,
              porcentaje_descuento: 0,
            })

          this.servicios = data_ov_rechazada.servicios.map((service) => ({
            nombre: service.servicio.nombre,
            precio: service.precio,
            cantidad: service.cantidad,
            id: service.servicio.id,
            porcentaje_descuento: service.porcentaje_descuento || 0,
          }))
        }
      }
    },
  },
}
</script>

<style lang="scss">
@import '@/style/colors.scss';
.ov_with_ot {
  max-height: 90vh;
  overflow-y: scroll;
}

.custom-input-border {
  border-top-color: #525252 !important;
  border-bottom-color: #525252 !important;
  border-right-color: #525252 !important;
}

.border-left-color-white {
  border-left-color: #fff !important;
}

.autocomplete-result-list {
  z-index: 2 !important;
}

.btn-add-item {
  background-color: transparent !important;
  color: black !important;
  border: none !important;
  cursor: pointer;
}

.icon-add {
  color: #fece2f;
}

.trash-icon {
  color: #ff3838 !important;
  cursor: pointer;
}

.readonly-value {
  border: none !important;
  height: 38px !important;
  display: flex !important;
  align-items: center !important;
  padding-left: 0 !important;
}

// Reservar espacio para mensajes de validación
.form-group {
  min-height: 70px; // Espacio para input + mensaje de error
  margin-bottom: 0;
  position: relative;
}

.invalid-feedback {
  position: absolute;
  bottom: -20px;
  left: 0;
  right: 0;
  font-size: 0.875rem;
  margin-top: 0.25rem;
  white-space: nowrap;
}

.form-subtitle {
  color: $samtek-black;
  display: flex;
  align-items: center;
  gap: 0.5em;
  padding-left: 0.5em;

  > h3 {
    font-weight: bold;
    font-size: 18px;
    margin: 0;
  }

  + hr {
    margin: 0.5em 0 1.5em;
  }
}

.categoria,
.comentarios {
  display: block;
  font-size: 15px;
  font-weight: normal;
}

.comentario_text,
.categoria_text {
  color: var(--grey-textos-525252, #525252);
  font-family: 'Noto Sans';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.subtitle_repuesto {
  color: var(--negro-textos-23201-c, #23201c);
  font-family: 'Noto Sans';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.title {
  color: var(--negro-textos-23201-c, #23201c);
  font-family: 'Noto Sans';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.textarea-height {
  height: 150px;
}

.col-precio {
  flex: 0 0 15%;
  max-width: 15%;
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}

.no-margin-bottom {
  margin-bottom: 0 !important;
}

.col-detalles {
  max-width: 18%;
  flex: 0 0 18%;
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}

.col-cantidad {
  max-width: 9%;
  flex: 0 0 9%;
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}

.col-descuento {
  max-width: 8%;
  flex: 0 0 8%;
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}

.pvp-info-line {
  font-family: 'Noto Sans', sans-serif;
  font-size: 20px;
  font-weight: 700;
  font-style: italic;
  color: #23201c;
  line-height: normal;
  letter-spacing: 0.2px;
  margin-bottom: 24px;
  margin-top: -65px;
  position: absolute;
  z-index: 10;
}

.col-partgroup {
  max-width: 10%;
  flex: 0 0 10%;
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}

.pvp-suggested {
  position: absolute;
  top: 100%;
  left: 0;
  font-size: 0.85rem;
  color: #23201c;
  margin-top: 2px;
  font-family: 'Noto Sans', sans-serif;
  white-space: nowrap;
}

.invalid-feedback ~ .pvp-suggested {
  margin-top: 20px;
}

.repuesto-header-row {
  margin-bottom: 0.5rem;
}
.repuesto-header-row label {
  font-weight: 600;
  margin-bottom: 0;
}
.repuesto-data-row {
  margin-bottom: 1rem;
}
</style>
